import { Link, useLocation } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function CheckEmail() {
  const location = useLocation();
  const email = location.state?.email || "";

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 font-mono text-sm text-zinc-500 hover:text-primary transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          VOLVER
        </Link>

        <div className="bg-[#111] border border-zinc-800 p-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <Mail className="w-8 h-8 text-primary" />
            </div>
            
            <h1 className="text-2xl font-black text-white mb-4">
              REVISA TU <span className="text-primary">EMAIL</span>
            </h1>
            
            <p className="text-zinc-400 mb-2">
              Hemos enviado un enlace de verificación a:
            </p>
            
            {email && (
              <p className="text-primary font-mono text-lg mb-6">
                {email}
              </p>
            )}
            
            <p className="text-zinc-500 text-sm mb-8">
              Haz clic en el enlace del email para completar tu registro.
              <br />
              El enlace expirará en 24 horas.
            </p>

            <div className="space-y-3">
              <Link to="/login">
                <Button variant="outline" className="w-full btn-ruido border-zinc-700 font-mono">
                  YA TENGO CUENTA
                </Button>
              </Link>
              
              <p className="text-zinc-600 text-xs">
                ¿No recibiste el email? Revisa tu carpeta de spam.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
